import '../../../assets/style/AUC2.css';

import { useTranslation } from "react-i18next";

function AUC2(params) {
    const { t } = useTranslation();

    return(
        <section className="AUC2">
            <div style={{width: '70%'}}>
                <img src="/photo/about1.webp"  className="imageAbout" alt="AboutUs"></img>

                <div className='tambahfotoAUC2Mobile'>
                    <div>
                        <img src="/photo/about2.webp"  className='imageAbout' alt="ab2"></img>
                    </div>
                    <div>
                        <img src="/photo/about3.webp"  className='imageAbout' alt="ab3"></img>
                    </div>
                </div>
            </div>
            <div className="rightAUC2">
                <h1 style={{fontSize: '32px'}}>{t("aboutuscontenttitle")}</h1>
                <p className="textAUC2">{t("aboutuscontenttext")}</p>
                <div className="photoAUC2 goneMobile">
                    <div>
                        <img src="/photo/about2.webp"  className="imageAbout" alt="AboutUs"/>
                    </div>
                    <div>
                        <img src="/photo/about3.webp"  className="imageAbout" alt="AboutUs"/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AUC2;